import { render } from "./HomeBanner.vue?vue&type=template&id=afe2556e"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"

import "./HomeBanner.vue?vue&type=style&index=0&id=afe2556e&lang=scss"

import exportComponent from "/home/forge/empireresidential.net/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__